import { OrganizationUIStyle } from '@/api/rest/resources/types/organization';
import { useUIStyle } from '@/hooks/useUIStyle';

import { DefaultPlotView } from './DefaultPlotView';
import { TabPlotView } from './TabPlotView';

export const PlotPage = () => {
  const displayTabPlotView = useUIStyle(OrganizationUIStyle.CONSERVATION);

  if (displayTabPlotView) {
    return <TabPlotView />;
  }

  return <DefaultPlotView />;
};
